import fp from "lodash/fp"

import type {
  RecordType,
  TableStatColumn,
  TableStatPlotView,
} from "types/dashboard.types"
import type { TableStatConfig } from "types/tableStatPlot.types"

interface TableStatConfigParams {
  view: TableStatPlotView
  data: RecordType[]
}

const gridTemplateForColumn = (column: TableStatColumn): string => {
  if (column.width) return column.width
  switch (column.type) {
    case "label":
      return "max-content"
    case "value":
      return "max-content"
    case "timestamp":
      return "max-content"
    case "percentageBar":
      return "1fr"
    default:
      return "auto"
  }
}

export default function tableStatConfig({
  view,
  data,
}: TableStatConfigParams): TableStatConfig {
  const {
    columns,
    rows,
    suffix = "",
    decimalPlaces = 0,
    threshold,
    seasonalThreshold,
  } = view.properties

  // All records grouped by field (needed for percentage computations).
  const recordsByField = fp.groupBy("_field", data) as Record<string, RecordType[]>

  const gridTemplateColumns = columns.map(gridTemplateForColumn).join(" ")

  return {
    columns,
    rows,
    recordsByField,
    gridTemplateColumns,
    suffix,
    decimalPlaces,
    threshold,
    seasonalThreshold,
    isEmpty: rows.length === 0,
  }
}
